// hooks - useScreenSize.js
import { useState, useEffect } from "react";

export const useScreenSize = (size) => {
    const [isLargeScreen, setIsLargeScreen] = useState(() => {
        return typeof window !== "undefined" ? window.innerWidth >= size : false;
    });

    useEffect(() => {
        const handleResize = () => {
        setIsLargeScreen(window.innerWidth >= 800);
        };

        handleResize(); // Initialisation
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isLargeScreen;
};
